import { selectAuthTokens } from "../../../../features/auth/selectors/auth.selector";
import { IListDto } from "../../../../interface/dto/list.dto";
import { createIGSERedux } from "../../../../shared/igse-redux/igse-redux-factory";
import { getHistory } from "../../service/history.api";

const {
    actions: historyActions,
    reducer: historyReducer,
    epic: historyEpic,
} = createIGSERedux<Array<IListDto>>({
    actionNames: {
        init: "HISTORY_INIT",
        get: "HISTORY_GET",
        success: "HISTORY_SUCCESS",
        error: "HISTORY_ERROR",
    },
    fetcher: () => getHistory(selectAuthTokens()),
});

export { historyActions, historyReducer, historyEpic };
